import { useEffect } from 'react';
import { useSiteData } from '../context/SiteContext';

export const SEOUpdater = () => {
  const { data } = useSiteData();

  useEffect(() => {
    if (!data?.seo) return;

    const seo = data.seo;

    // Обновляем Title
    if (seo.title) {
      document.title = seo.title;
    }

    // Обновляем Description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && seo.description) {
      metaDesc.setAttribute('content', seo.description);
    }

    // Обновляем Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords && seo.keywords) {
      metaKeywords.setAttribute('content', seo.keywords);
    }

    // Обновляем LocalBusiness Schema
    if (seo.local_business) {
      let scriptTag = document.querySelector('#seo-local-business');
      
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.id = 'seo-local-business';
        scriptTag.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptTag);
      }
      
      const ldJson = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": seo.local_business.name,
        "image": seo.local_business.image,
        "@id": window.location.origin,
        "url": window.location.origin,
        "telephone": seo.local_business.telephone,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": seo.local_business.streetAddress,
          "addressLocality": seo.local_business.addressLocality,
          "addressRegion": seo.local_business.addressRegion,
          "postalCode": seo.local_business.postalCode,
          "addressCountry": "RU"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": seo.local_business.latitude,
          "longitude": seo.local_business.longitude
        },
        "priceRange": seo.local_business.priceRange
      };
      
      scriptTag.textContent = JSON.stringify(ldJson);
    }
  }, [data]);

  return null;
};